import { AmrSource } from "../api";

export const GENOMES_PER_PAGE = 30;
export const MAX_SEQUENCE_SEARCH_RESULTS = 5;
export const AMR_SOURCES: AmrSource[] = ["CARD", "ResFinder", "AMR Finder"];

export const CONSENT_COOKIE_NAME = "cookie-consent";
export const DISMISSED_BANNERS_COOKIE_NAME = "dismissed-banners";
export const STRIPE_REDIRECT_NOTICE_COOKIE_NAME = "stripe-redirect-notice";
export const AFTER_LOGIN_ACTION_COOKIE_NAME = "after-login-redirect-to";
export const DO_NOT_ASK_ABOUT_REDIRECTING_TO_OCX_COOKIE_NAME = "just-redirect-to-ocx";
